const KEY = "PRODUCT";

export const CHECK_REQUEST = `CHECK_${KEY}_REQUEST`;
export const CHECK_SUCCESS = `CHECK_${KEY}_SUCCESS`;
export const CHECK_ERROR = `CHECK_${KEY}_ERROR`;
